import React, { useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { PlainTextHeader } from 'Deer/components/HeaderComponents/PlainTextHeader';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { Container } from 'styles/admin';

import { sendPageViewEvent } from 'constants/mixpanelHelper';

import { TextLabel } from 'uiToolkitV1/Typography';

import { NotificationSettingsProvider } from './Context/NotificationSettingsContext';
import NotificationChannels from './NotificationChannels';
import NotificationEvent from './NotificationEvent';
import NotificationSettingsFooter from './NotificationSettingsFooter';

const HeaderComp = ({ isEmployeeNotificationSettings }) => {
  const heading = isEmployeeNotificationSettings ? 'Notifications' : 'Organisation notifications';
  const subHeading = isEmployeeNotificationSettings
    ? 'Select how do you want to get notified'
    : 'Select how do you want your people to get notified';

  return (
    <Box>
      <PlainTextHeader>{heading}</PlainTextHeader>
      <TextLabel color="text.g2" mb={2}>
        {subHeading}
      </TextLabel>
    </Box>
  );
};

/**
 * @deprecated 8-04-2025
 */
const NotificationsDeer = ({ isEmployeeNotificationSettings = false }) => {
  const { l1Module } = useRouteToNavLevels();
  const isMyData = l1Module === 'myData';
  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        source: isMyData ? 'Me-settings-notifications' : 'Company-settings-notifications',
      },
    });
  }, [isMyData]);
  return (
    <NotificationSettingsProvider>
      <Container style={{ height: 'auto' }}>
        <HeaderComp isEmployeeNotificationSettings={isEmployeeNotificationSettings} />
        <NotificationChannels isEmployeeNotificationSettings={isEmployeeNotificationSettings} />
        <NotificationEvent isEmployeeNotificationSettings={isEmployeeNotificationSettings} />
        <NotificationSettingsFooter isEmployeeNotificationSettings={isEmployeeNotificationSettings} />
      </Container>
    </NotificationSettingsProvider>
  );
};

export default NotificationsDeer;
